<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Week Schedule</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-8">
                        <div class="col-span-4 sm:col-span-4">
                            <FormMultiselect
                                @change="getBatches"
                                :required="true"
                                label="Course Year"
                                :options="options"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                placeholder="Select Course Year"
                                v-model="form.courseyear"
                                :error="form.errors.courseyear"
                            />
                        </div>
                        <div class="col-span-2 sm:col-span-2">

                            <FormMultiselect
                                label="Course Semester"
                                :options="allSemesters"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                :required="true"
                                placeholder="Select Semester"
                                v-model="form.semester"
                                :error="form.errors.semester"
                            />

                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <FormMultiselect
                                label="Course Batch"
                                :options="allBatches"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                :required="true"
                                placeholder="Select Batch"
                                v-model="form.batch"
                                :error="form.errors.batch"
                            />
                        </div>


                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Start Time'"/>
                            <breeze-input type="time" required v-model="form.start_time" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.start_time:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'End Time'"/>
                            <breeze-input type="time" required v-model="form.end_time" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.end_time:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Interval in Mins'"/>
                            <breeze-input class="w-full" type="number" v-model="form.interval"/>
                            <breeze-input-error :message="form.errors?form.errors.interval:''"/>
                        </div>
                        <!-- <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''"/>
                        </div> -->
                    </div>
                    <button-link :href="route('internal.weekschedule.list',branchid)"
                                 class="bg-red-500 mr-4 hover:bg-red-400">Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Submit</breeze-button>
                    <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Week Schedule Added!</span>
                    <exception/>
                </form>
            </div>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import ButtonLink from '@/Components/ButtonLink'
import CardHeader from '@/Components/CardHeader'
import {useForm} from '@inertiajs/inertia-vue3'
import BreezeInputError from '@/Components/InputError'
import Exception from '@/Components/Exception'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import Loading from '@/Components/Loading'
import SelectList from '@/Components/SelectList'
import BreezeTable from '@/Components/Table'
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Internal,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        Loading,
        Exception,
        BreezeTable,
        SelectList
    },
    props: ['courseyears'],
    data() {
        return {
            form: useForm({
                courseyear: '',
                batch: '',
                semester: '',
                start_time: '',
                end_time: '',
                interval: '',
                status: true,
            }),
            fields: [{'key': 'title', 'label': 'Title'}, {'key': 'status', 'label': 'Status'}, {
                'key': 'action',
                'label': 'Action'
            }],
            branchid: localStorage.branchId,
            batches: [],
            semesters: [],
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('internal.weekschedule.store', this.branchid), {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.reset();
                    location.reload()
                },
            });
        },
        getBatches(value) {
            window.axios.get(route('internal.weekschedule.getbatches'), {params: {courseyear: value?.id}})
                .then(res => {
                    this.batches = res.data

                })
            window.axios.get(route('internal.weekschedule.getsemesters'), {params: {courseyear: value?.id}})
                .then(res => {
                    this.semesters = res.data
                })
            this.form.semester = [];
            this.form.batch = [];
        }
    },
    computed: {
        options() {
            var options = [];
            this.courseyears.forEach(courseyear => {
                options.push({
                    id: courseyear.id,
                    title: courseyear.course.title + ' - ' + courseyear.title + ' - ' + courseyear.duration.start_month
                });
            });
            return options;
        },
        allBatches() {
            var allBatches = [];
            this.batches.forEach(batch => {
                allBatches.push({id: batch.id, title: batch.title});
            });
            return allBatches;
        },
        allSemesters() {
            var allSemesters = [];
            this.semesters.forEach(semester => {
                allSemesters.push({id: semester.id, title: semester.title});
            });
            return allSemesters;
        }
    }
}
</script>
